/**
 * @fileoverview Prompt template for world-event-ideation-v3.
 */

export const prompt = `
You are an expert world-builder specializing in creating rich historical events, prophecies, and legends for fiction.

## TASK INSTRUCTIONS:
Your task is to analyze the provided story context and generate ideas for significant events that could exist in the story world's history, mythology, or future.

{{#if targetElement}}
**IMPORTANT: Generate ONLY {{targetElement}}s. Do not generate any other element type.**
{{/if}}

1. Review the existing world events to avoid duplicates.
2. Based on the story context, generate a list of *new* events that would add depth and richness to the story world.
{{#if targetElement}}
{{#eq targetElement "historical-event"}}
   - Focus exclusively on **Historical Events**: Past occurrences that shaped the world (e.g., The Great Cataclysm, The Founding of the Republic, The Fall of the Old Gods, a pivotal war or revolution).
{{/eq}}
{{#eq targetElement "prophecy"}}
   - Focus exclusively on **Prophecies**: Foretold future events that characters believe in or fear (e.g., "The Chosen One shall rise when the stars align", "The machine uprising is inevitable").
{{/eq}}
{{#eq targetElement "legend"}}
   - Focus exclusively on **Legends**: Mythical or semi-historical stories passed down through generations (e.g., The Tale of the First King, The Myth of Creation, The Legend of Atlantis).
{{/eq}}
{{else}}
   - **Historical Events**: Past occurrences that shaped the world (e.g., The Great Cataclysm, The Founding of the Republic).
   - **Prophecies**: Foretold future events that characters believe in or fear (e.g., "The Chosen One shall rise when the stars align").
   - **Legends**: Mythical or semi-historical stories passed down through generations (e.g., The Tale of the First King).
{{/if}}
3. Prioritize events that:
   - Are critical to understanding the world's current state
   - Create narrative tension or mystery
   - Connect to characters, places, or organizations
   - Have lasting consequences still felt in the story's present
   - Offer potential for plot twists or revelations
4. Compare ideated events with existing ones. Only return events that don't exist yet.

<<<userMessage>>>

## PRIMARY TASK CONTEXT

<<<loreContext>>>

<<<storyContext>>>

<<<initialChapterContent>>>

## SECONDARY TASK CONTEXT

<<<worldEvents>>>

<<<worldElements>>>

<<<characters>>>

## OUTPUT INSTRUCTIONS:
For each event, you MUST provide:
- **name**: A distinctive name for the event
{{#if targetElement}}
- **element**: Must be "{{targetElement}}" for all events (as specified in the task instructions)
{{else}}
- **element**: Either "historical-event" (past occurrence), "prophecy" (foretold future), or "legend" (mythical story)
{{/if}}
- **initialDescription**: A compelling description covering what the event is, its significance, and why it matters to the story

Provide your output in the required JSON format.
`;
